<template>
  <button
    class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mdc-ripple-upgraded"
    @click="disabledButton ? '' : enrollMicroDegree(degreeData)"
    :class="disabledButton ? 't-color-disableBtnText bg-disableBtn' : ''"
    :disabled="disabledButton"
  >
    <div class="mdc-button__ripple"></div>
    <span class="mdc-button__label t-body2">
      {{ $t(buttonText, buttonDateText) }}
    </span>
  </button>
</template>

<script>
/**
 * Micro Degree Status Button Component
 * @author jaehyub.lee@emcast.com
 */
import moment from "moment";
import salesApi from "@/api/salesApi.js";
import microDegreeApi from "@/api/microDegreeApi.js";

export default {
  name: "ApplyStatusButton",
  props: ["degreeData"],
  data() {
    return {
      buttonText: "30008",
      buttonDateText: null,
      disabledButton: false,
      statusObj: {
        ENTER: "ENTER", // 신청하기 (수강신청가능)
        ENTER_REJECT: "ENTER_REJECT", // 신청하기 (수강신청가능 && 수강거절)
        ENTER_REQUEST: "ENTER_REQUEST", // 승인대기중 (수강신청가능 && 수강요청) - disabled
        ENTER_APPROVAL: "ENTER_APPROVAL", // 구매하기 (수강신청가능 && 수강승인)
        BEFORE_ENTER: "BEFORE_ENTER", // ${날짜}부터 수강 신청 가능 (수강신청대기) - disabled
        END_ENTER: "END_ENTER", // 수강신청마감 (수강신청기간만료) - disabled
        BEFORE_LEARNING_APPROVAL: "BEFORE_LEARNING_APPROVAL", // 학습하기 (학습시작가능)
      },
    };
  },

  created() {
    this.setButtonText();
  },

  methods: {
    // actionType Status에 따라 분기하는 함수
    checkStatus(status) {
      return this.statusObj[status];
    },

    setButtonText() {
      switch (this.checkStatus(this.degreeData.action.status.value)) {
        case this.statusObj.ENTER:
        case this.statusObj.ENTER_REJECT:
          this.buttonText = "30008"; // 신청하기
          this.buttonDateText = null;
          this.disabledButton = false;
          break;

        case this.statusObj.ENTER_REQUEST:
          this.buttonText = "30238"; // 승인대기중 (수강신청가능 && 수강요청) - disabled
          this.buttonDateText = null;
          this.disabledButton = true;
          break;

        case this.statusObj.ENTER_APPROVAL:
          this.buttonText = "30241"; // 구매하기
          this.buttonDateText = null;
          this.disabledButton = false;
          break;

        case this.statusObj.BEFORE_ENTER:
          microDegreeApi
            .getPeriod({
              degreeId: this.degreeData.id,
            })
            .then((res) => {
              this.buttonText = "30239"; // ${날짜}부터 수강 신청 가능 (수강신청대기) - disabled
              this.buttonDateText = {
                str: moment(res.data.data.register.start).format("YYYY.MM.DD"),
              };
              this.disabledButton = true;
            })
            .catch((err) => console.log(err));
          break;

        case this.statusObj.END_ENTER:
          this.buttonText = "30247"; // 수강신청마감 (수강신청기간만료) - disabled
          this.buttonDateText = null;
          this.disabledButton = true;
          break;

        case this.statusObj.BEFORE_LEARNING_APPROVAL:
          this.buttonText = "30249"; // 학습하기
          this.buttonDateText = null;
          this.disabledButton = false;
          break;

        default:
          this.buttonText = "30008"; // 신청하기
          this.buttonDateText = null;
          this.disabledButton = false;
          break;
      }
    },

    async enrollMicroDegree(degreeData) {
      switch (this.checkStatus(degreeData.action.status.value)) {
        case this.statusObj.ENTER:
        case this.statusObj.ENTER_REJECT:
          try {
            const confirmResult = await this.makeConfirmMessage({
              title:
                this.checkStatus(degreeData.action.status.value) === "ENTER"
                  ? this.$t("30250") // 강의를 신청하시겠습니까?
                  : this.$t("30254"), // 기존에 신청한 강의 입니다.
              content:
                this.checkStatus(degreeData.action.status.value) === "ENTER"
                  ? this.$t("30251") // 이 강의는 신청 후 관리자의 승인이 필요합니다. 수강 신청을 계속하시겠습니까?
                  : this.$t("30255"), // 현재 수강 신청이 반려된 상태입니다. 다시 신청하시겠습니까?
            });

            if (confirmResult) {
              await microDegreeApi.postRegistDegree({
                degreeId: degreeData.id,
              });
              await this.$alert({
                title: this.$t("30258"), // 신청이 완료 되었습니다.
                content: this.$t("30259"), // 수강 신청이 승인될 때까지 잠시만 기다려 주세요.
                accept: this.$t("30260"), // 닫기
              });

              window.location.reload();
            }
          } catch (error) {
            console.log("Apply Fetch Error : ", error);
          }
          break;

        case this.statusObj.ENTER_APPROVAL: // 구매하기
          this.$route.query.fetchType = "LEARN";
          localStorage.setItem("productId", degreeData.id);
          let confirmResult = await this.makeConfirmMessage({
            title: this.$t("30261"), // 상품을 구매하시겠습니까?
            content: this.$t("30262"), // 수강 신청이 승인되어 구매가 가능합니다.
          });

          if (confirmResult) {
            try {
              let salesResult = await salesApi.salesMicroGoodsPurchased({
                goodsId: degreeData.goods.id,
              });

              // TODO : 수강생 구매 내역이 확인해보기
              console.log("구매 조회 이력 RESULT : ", salesResult);
              if (
                salesResult.status === 200 &&
                salesResult.data.data &&
                salesResult.data.data.length > 0
              ) {
                this.$router.push({
                  name: "SalesDuplicate",
                  params: { goodsid: degreeData.goods.id },
                  query: { ...this.$router.query, type: "MICRO" },
                });
              } else {
                this.$router.push({
                  name: "SalesInformation",
                  params: { goodsid: degreeData.goods.id },
                  query: { ...this.$router.query, type: "MICRO" },
                });
              }
            } catch (error) {
              console.log("Sales Error : ", error);
            }
          }
          break;

        case this.statusObj.BEFORE_LEARNING_APPROVAL: // 학습하기
          try {
            const periodResult = await microDegreeApi.getPeriod({
              degreeId: degreeData.id,
            });
            const degreeResult = await microDegreeApi.getRegistedDegree({
              degreeId: degreeData.id,
            });

            const { start, end } = periodResult.data.data.learning;
            let title = "";
            let content = "";

            if (moment().isBefore(moment(start))) {
              // 오늘이 학습시작일 보다 이전이라면
              if (moment().isBefore(moment(end))) {
                title = "30269"; // 아직 학습할 수 없는 강의입니다.
                content = "30270"; // 학습기간 정보를 확인해주세요. 나의 스킬패스로 이동하시겠습니까?
              } else {
                title = "30273"; // 학습 기간이 종료되었습니다.
                content = "30274"; // "학습기간 정보를 확인해주세요. 나의 스킬패스로 이동하시겠습니까?"
              }
            } else {
              title = "30265"; // 학습을 진행하시겠습니까?
              content = "30266"; // 이미 학습 중인 강의입니다. 나의 스킬 패스로 이동하시겠습니까?
            }

            const confirmResult = await this.makeConfirmMessage({
              title: this.$t(title),
              content: this.$t(content),
            });

            if (confirmResult) {
              this.$router.push({
                name: "MicroDegreeView",
                params: {
                  learnId: degreeData.action.learnerId,
                },
              });
            }
          } catch (error) {
            console.log("Study Error : ", error);
          }
          break;

        default:
          console.log("No Action Default - Contact Manager");
          break;
      }
    },

    makeConfirmMessage(msgParams) {
      let msg = {
        accept: this.$t("30256"), // 확인,
        cancel: this.$t("983"), // 취소
      };
      msgParams.title ? (msg["title"] = msgParams.title) : null;
      msgParams.content ? (msg["content"] = msgParams.content) : null;
      msgParams.cancel ? (msg["cancel"] = msgParams.cancel) : null;
      msgParams.accept ? (msg["accept"] = msgParams.accept) : null;
      return this.$confirm(msg);
    },
  },
};
</script>

<style scoped></style>
